import { g as r } from "./global.js";
var t = function t(_t) {
  return r[_t].prototype;
};
export { t as e };